import React from 'react';
import { CSSMailItemBody } from '../styles';
import { JRCTypography } from 'components/JRCTypography/JRCTypography';
export const WidgetEmailsItemBody = ({
    text,
    read,
    maxHeight = 36,
}: {
    text: string;
    read: boolean;
    maxHeight?: number;
}) => {
    return (
        <CSSMailItemBody maxHeight={maxHeight}>
            <JRCTypography weight="normal" color={read ? 'grey4' : 'grey5'} size={'s'}>
                {text}
            </JRCTypography>
        </CSSMailItemBody>
    );
};
